import { ReportListTable } from './ReportListTable'
import { withReportListTable } from './withReportListTable'

const ConnectedReportListTable = withReportListTable(ReportListTable)
export { ConnectedReportListTable as ReportListTable }
